import { render, staticRenderFns } from "./CardOpcaoEnquete.vue?vue&type=template&id=28bda9b6&scoped=true"
import script from "./CardOpcaoEnquete.vue?vue&type=script&lang=js"
export * from "./CardOpcaoEnquete.vue?vue&type=script&lang=js"
import style0 from "./CardOpcaoEnquete.vue?vue&type=style&index=0&id=28bda9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bda9b6",
  null
  
)

export default component.exports